var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headd,"items":_vm.taxonss},scopedSlots:_vm._u([{key:"item.id_taxon",fn:function(ref){
var item = ref.item;
return [(item.id_taxon)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v(" mdi-check-circle ")]):_vm._e(),(!item.id_taxon)?_c('v-icon',{attrs:{"color":"error"}},[_vm._v(" mdi-close-circle ")]):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }